import { FileText, Search } from 'lucide-react'
import React from 'react'

import MarkCard from './components/marks/Index'
import PalletCard from './components/pallet/Index'
import PositionCard from './components/position/Index'
import SearchForm from './components/SearchForm'
import { useSearchState } from './stores/search'

const UniversalSearch: React.FC = () => {
  const { searchResult, queryType } = useSearchState()

  return (
    <div className="max-w-7xl mx-auto">
      <div className="bg-gray-50 flex flex-col">
        {/* 主要内容区域 */}
        <div className="flex-1 p-4">
          {/* 搜索区域 */}
          <SearchForm />

          {/* 查询结果 */}
          {searchResult && (
            <div className="mt-6">
              {/* 搜索结果概览 */}
              <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                <div className="px-6 py-4 border-b border-gray-200">
                  <div className="flex items-center justify-between">
                    <h2 className="text-xl font-semibold text-gray-900 flex items-center">
                      <FileText className="w-6 h-6 text-green-500 mr-2" />
                      搜索结果
                    </h2>
                  </div>
                </div>

                <div className="px-6 py-2">
                  {searchResult === null ? (
                    <div className="text-center py-12">
                      <div className="bg-gray-100 p-4 rounded-lg inline-block mb-4">
                        <Search className="w-12 h-12 text-gray-400 mx-auto" />
                      </div>
                      <h3 className="text-lg font-medium text-gray-900 mb-2">
                        未找到匹配的结果
                      </h3>
                      <p className="text-gray-500">
                        请检查输入内容是否正确，或尝试其他关键词
                      </p>
                    </div>
                  ) : (
                    <div className="space-y-6">
                      {queryType === 'pallet' && <PalletCard />}
                      {queryType === 'mark' && <MarkCard />}
                      {queryType === 'position' && <PositionCard />}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default UniversalSearch
